import http from '../common/http'

export const CreateCheck = param => (
    http.post('/RepairCheck/CreatedRepairCheck', param)
)

export const GetCheck = param => (
    http.get('/RepairCheck/GetRepairCheck', param)
)

export const GetBrand = () => (
    http.get('/RepairCheck/GetBrand')
)

export const GetModle = param => (
    http.get('/RepairCheck/GetModle', param)
)

export const GetAppearance = () => (
    http.get('/RepairCheck/TakeAppearance')
)

export const GetAttachment = () => (
    http.get('/RepairCheck/TakeAttachment')
)

export const GetCheckOptions = () => (
    http.get('/RepairCheck/TakeCheckOptions')
)

export const CreateRepaireCheckExt = param => (
	http.get('/RepairCheck/CreateRepairCheckExt', param)
)

export const ExistsRepairCheckExt = param => (
	http.get('/RepairCheck/ExistsRepairCheckExt', param)
)

export const GetWfcOrderBrand = param => (
    http.get('/RepairCheck/GetOrderBrand', param)
)



// WEBPACK FOOTER //
// ./src/api/repairCheckApi.js